module.exports = __webpack_public_path__ + "img/t7-3.c34b3e28.svg";